module.exports = __webpack_public_path__ + "fonts/fontello.18ecb1f.woff";